import React from 'react';
import PropTypes from 'prop-types';
import {
  renderNameGreeting,
  determineGreetingByTimeOfDay,
} from '../utils';
import useBreakpoint from '../../../hooks/useBreakpoint';

// eslint-disable-next-line eslint-comments/disable-enable-pair -- needed
/* eslint-disable react/no-danger -- needed */

const CardMemberInfo = ({
  cardImage,
  cardName,
  displayName,
  lastDigits,
  languageData,
}) => {
  const isXSmallBreakpoint = useBreakpoint('xSmall');

  if (isXSmallBreakpoint) {
    return (
      <div>
        <div className="row">
          <div className="col-xs-12 col-sm-8 margin-auto-lr">
            <img
              src={cardImage}
              alt=""
              className="pad-1-b"
            />
          </div>
        </div>
        <div className="text-align-center">
          <div className="body-bold pad-1-b">
            {renderNameGreeting(determineGreetingByTimeOfDay(
              new Date(), languageData), displayName)}
          </div>
          <div>
            <span dangerouslySetInnerHTML={{ __html: cardName }} />
            <p>-{lastDigits}</p>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div>
      <div className="row flex-justify-center">
        <div className="col-xs-12 col-sm-4">
          <img
            src={cardImage}
            alt=""
            className="float-left"
          />
        </div>
        <div className="flex flex-column text-align-center-xs-down flex-justify-center margin-2-t-sm-down col-xs-12 col-sm-5">
          <div className="body-bold pad-1-b">
            {renderNameGreeting(determineGreetingByTimeOfDay(
              new Date(), languageData), displayName)}
          </div>
          <div>
            <span dangerouslySetInnerHTML={{ __html: cardName }} />
            <p>-{lastDigits}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

CardMemberInfo.propTypes = {
  cardImage: PropTypes.string.isRequired,
  cardName: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  lastDigits: PropTypes.string.isRequired,
  languageData: PropTypes.shape({}).isRequired,
};

export default CardMemberInfo;
